var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paper",attrs:{"oncontextmenu":"return false;"}},[_c('resize-observer',{on:{"notify":_vm.onresize}}),_vm._v(" "),_c('canvas',{ref:"canvas",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id,"resize":""},on:{"click":_vm.activate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbdec126","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets/Tools/Paper.vue
// module id = null
// module chunks = 